export const ru = {
  popularExcursions: 'Популярные экскурсии {place}',
};
